import React, {useState, useEffect} from "react";

import { Button, Modal, Select, Radio } from 'antd';

import Card from '../card/card';
import styled from "styled-components";
import {useStore} from "react-context-hook";

const defaultCardHeight = 160;

const HandWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-around;
`;

const CardWrapper = styled.div`
    margin: 4px 54px 4px 4px;
`;

const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: row;
`;

const StyledButton = styled(Button)`
    margin-right: 32px;
`;

const PASS_ACTION_NUMBER = 65

const HandCards = ({ player, handcards, cardHeight, socket, showButtons }) => {

    const [gameState, ] = useStore('game', {});

    const {possibleActions, currentPlayer } = gameState;

    const playersTurn = currentPlayer === player;

    const [selectedCards, setSelectedCards] = useState(handcards.map(() => false));

    const passActionAllowed = (possibleActions.filter(item => item.number === PASS_ACTION_NUMBER).length > 0);

    const onCardSelect = (index) => {
        const newSelectedCards = [...selectedCards];
        newSelectedCards[index] = !selectedCards[index];
        setSelectedCards(newSelectedCards);
    }
    useEffect(() => {
        if (handcards.length !== selectedCards.length) {
            setSelectedCards(handcards.map(() => false));
        }
    }, [handcards]);

    const oneSelected = selectedCards.filter(v => v).length > 0;

    const onCombinatonPlayClick = () => {
        const selectedHandcards = handcards.filter((value, index) => selectedCards[index]);
        if (window.gtag) {
            window.gtag('event', 'combination', {
                'event_category': 'game',
                'event_label': 'Player played combination',
            });
        }
        socket.emit('play_combination', {cards: selectedHandcards});
        console.log(selectedHandcards);
    }

    const onPass = () => {
        socket.emit('next_action', {action: PASS_ACTION_NUMBER});
        if (window.gtag) {
            window.gtag('event', 'pass', {
                'event_category': 'game',
                'event_label': 'Player passed',
            });
        }
    };


    return (
        <HandWrapper>
            {showButtons && (<ButtonWrapper>
                <StyledButton type="secondary" disabled={!playersTurn || !passActionAllowed} danger onClick={onPass}>Pass</StyledButton>
                <Button type="primary" disabled={!oneSelected || !playersTurn} onClick={onCombinatonPlayClick}>Play Combination</Button>
            </ButtonWrapper>)}
            <CardWrapper >
                {handcards.map((value, index) => (
                    <Card value={value} key={`item-${value}`} onClick={onCardSelect} selected={selectedCards[index]} index={index} height={cardHeight || defaultCardHeight}/>
                ))}
            </CardWrapper>
        </HandWrapper>
    );
};

export default HandCards;